/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S11_Li4_TextInputs */

const tr_onbilgi_s11_li4_text = /** @type {(inputs: Onbilgi_S11_Li4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform mobil uyumlu (responsive) olarak sunulur. Native mobil uygulama yayını planlanmaktadır; durumu pazara çıkış tarihinde duyurulacaktır.`)
};

const en_onbilgi_s11_li4_text = /** @type {(inputs: Onbilgi_S11_Li4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Platform is provided in mobile compatible (responsive) form. Release of a native mobile application is planned; its status will be announced on the market launch date.`)
};

const de_onbilgi_s11_li4_text = /** @type {(inputs: Onbilgi_S11_Li4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Plattform wird mobiltauglich (responsive) bereitgestellt. Die Veröffentlichung einer nativen mobilen Anwendung ist geplant; der Stand wird zum Zeitpunkt des Markteintritts bekannt gegeben.`)
};

const ru_onbilgi_s11_li4_text = /** @type {(inputs: Onbilgi_S11_Li4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформа предоставляется в мобильно совместимом (адаптивном) виде. Выпуск нативного мобильного приложения планируется; его статус будет объявлен на дату выхода на рынок.`)
};

/**
* | output |
* | --- |
* | "The Platform is provided in mobile compatible (responsive) form. Release of a native mobile application is planned; its status will be announced on the marke..." |
*
* @param {Onbilgi_S11_Li4_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s11_li4_text = /** @type {((inputs?: Onbilgi_S11_Li4_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S11_Li4_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s11_li4_text(inputs)
	if (locale === "de") return de_onbilgi_s11_li4_text(inputs)
	if (locale === "ru") return ru_onbilgi_s11_li4_text(inputs)
	return tr_onbilgi_s11_li4_text(inputs)
});